import React from 'react';
import HTTP from './http';

import ArticleGridPart from './ArticleGridPart';

class MoreArticles extends React.Component {

   constructor(props) {
      super(props);

      this.state = {
      	articleGrid:[],
      	moreBTNTxt:specialObj.acf.components.browse_more_txt,
      	paged:1,
      	canLoadMore:true
      };

     this.loadMore = this.loadMore.bind(this);
     this.goToBlog = this.goToBlog.bind(this);
     this.buttonAction = this.buttonAction.bind(this);
     this.getBTN = this.getBTN.bind(this);
     this.printTheGrid = this.printTheGrid.bind(this);
}

loadMore(){
	let offset;
	switch(this.props.currentpage) {
    case 'HOME':
        offset = 0;
        break;
    case 'BLOG':
        offset = 16;
        break;
    case 'ARCHIVE':
        offset = 13;
        break;
    case 'SEARCH':
        offset = 5;
        break;        
    default:
        offset = 5;
	}

  //redefine offset 
  offset = (this.props.type === 'GRID' || this.props.currentpage === 'HOME' || this.props.currentpage === 'SEARCH') ? offset : 3; //if layout is LIST offset is always 3 exept in front and search page

  const postPerPage = (this.props.type === 'GRID') ? 8 : 3; // set post per page by layout type

  const searchTerm = (this.props.searchterm) ? this.props.searchterm : null;
	let url = `${specialObj.home}/wp-json/agenda/v1/load_more/${this.props.currentpage}/${this.state.paged}/${postPerPage}/${offset}/${this.props.type}/${specialObj.currentCat}/${searchTerm}`;

  HTTP.get(url)
      .then((response) => {
      	const parsedResponse = JSON.parse(response.data);
        // console.log(parsedResponse.totalPaged);
      	if(this.state.canLoadMore){ //is it possible to load more?

      		if((this.props.currentpage === 'HOME' || this.props.currentpage === 'SINGLE')){//is front page
	      		this.setState({
              articleGrid: [...this.state.articleGrid, parsedResponse.htmlData],
	      			canLoadMore:false,
	      			moreBTNTxt:specialObj.acf.components.all_articles_link_text,
	      		});
	      	}else{
              let curPage = (this.props.currentpage === 'BLOG') ? this.state.paged : this.state.paged + 1;
	      		this.setState({
		      		articleGrid: [...this.state.articleGrid, parsedResponse.htmlData],
		      		paged:this.state.paged + 1,
		      		totalPages:parsedResponse.totalPaged,
		      		canLoadMore:(parsedResponse.totalPaged > curPage) ? true : false
      			});

	      	}

	      	

      	}

    });    

}

goToBlog(){ // go to all posts' page
	window.location.href = specialObj.blog;
}

buttonAction(){
	(this.state.canLoadMore === true) ? this.loadMore() : this.goToBlog();
}

getBTN(){
	if(this.state.canLoadMore === false && this.props.currentpage !== 'HOME'){
      return;
	}else{
		return(
		<div className="col-12 text-center">
			<button className="browse-more ff-ag-r fs-16" onClick={this.buttonAction}>
		      	{this.state.moreBTNTxt}
		    </button>
	    </div>
	      	);
	}
	
}

printTheGrid(){
  let counter = 0;
  return this.state.articleGrid.map((gridPart) => {
    counter++;
    return(<ArticleGridPart key={counter} articlepart={gridPart} />);
  });

     
  
}
  
render() {
  // console.log(this.props.currentpage);
  return (
      <div className="row">
      {this.printTheGrid()}
      {this.getBTN()}
      </div>
  );
}

}

export default MoreArticles;



// WEBPACK FOOTER //
// ./js/components/MoreArticles.js